import React from 'react';

const AllowExtraTimeIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path stroke="#2B73C7" strokeLinecap="round" strokeLinejoin="round" d="M9.55 3.8L9.55 9.495 12.75 11.8" transform="translate(-653 -63) translate(654 64)" />
            <g>
              <g stroke="#2B73C7" transform="translate(-653 -63) translate(654 64)">
                <circle cx="9.5" cy="9.5" r="9.5" />
              </g>
              <path fill="#2B73C7" fillRule="nonzero" stroke="#FFF" d="M19.3-.5h-2.6v3.2h-3.2v2.6h3.2v3.2h2.6V5.3h3.2V2.7h-3.2V-.5z" transform="translate(-653 -63) translate(654 64)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AllowExtraTimeIcon;
